// extracted by mini-css-extract-plugin
export default {"icon":"InfoMark_icon__FTAcA"};